module.exports = __webpack_public_path__ + "img/gaming.9be559aa.png";